/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const ScissorsIcon = createIcon(
  '0 0 20 20',
  <g>
    <path
      fillRule="evenodd"
      d="M5.5 2a3.5 3.5 0 0 1 3.297 4.676L19.06 16.939a3 3 0 0 1-4.243 0L10 12.122l-1.203 1.202a3.5 3.5 0 1 1-2.121-2.121L7.879 10 6.676 8.797A3.5 3.5 0 1 1 5.5 2m0 11a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0-9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      clipRule="evenodd"
    />
    <path d="m19.06 3.06-5.542 5.544-2.122-2.122 3.422-3.421a3 3 0 0 1 4.243 0" />
  </g>,
);
